export default "__VITE_ASSET__1c0fc0dc__"